import BaseAPI from "../api";

const path: string = "/advisor-estimate";

export type listType = {
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
};

export class advisorEstimateApi extends BaseAPI {
  static getEstimateById(id: number, token?: string): Promise<any> {
    if (!token) {
      return this.api.get(`${path}/advisor_student/${id}`);
    } else {
    return this.api.get(`${path}/advisor_student/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    }
  }

  static votingEstimate(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/advisor_student/${id}`, body);
  }
  static post(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
}
